const AbstractPayyoRequestRecord = require('./AbstractPayyoRequestRecord');
const PayyoTransactionType = require('@/lib/PaymentMethods/Payyo/Enums/PayyoTransactionType');
const { removeNullValues } = require('@/functions/functions');

class PayyoCreatePaymentRequestRecord extends AbstractPayyoRequestRecord {
    constructor(paymentData) {
        super(
            'POST',
            'payments'
        );

        if (!paymentData) {
            throw new Error('paymentData object is required');
        }

        if (!paymentData.amount) {
            throw new Error('amount is required');
        }

        if (!paymentData.description) {
            throw new Error('description is required');
        }

        if (!paymentData.currency) {
            throw new Error('currency is required');
        }

        if (!paymentData.device_id) {
            throw new Error('device_id is required');
        }

        if (!paymentData.reference) {
            throw new Error('reference is required');
        }

        if (!paymentData.payment_methods) {
            throw new Error('payment_methods is required');
        }

        if (
            !(PayyoTransactionType.CARD_PRESENT in paymentData.payment_methods)
            && !(PayyoTransactionType.CARD_MOTO in paymentData.payment_methods)
        ) {
            throw new Error('payment_methods should contain either a card_present or a card object');
        }

        this.data = removeNullValues(paymentData, true);

        this.headers = {
            // paymentData.reference is populated by DigiTickets payment.thirdPartyId.
            // Header is kebab case because of AWS gateway normalisation behaviour.
            'idempotency-key': paymentData.reference + 'createPayment',
        };
    }
}

module.exports = PayyoCreatePaymentRequestRecord;
